import { MyModel, MyModelDetail } from "@/types/creatorcenter";
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Text,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { RiBox3Line } from "@remixicon/react";
import { useEffect, useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import modelImg from "@/assets/images/creator_model_img1.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import { useLazyGetTrainsQuery } from "@/services/api/endpoints/model";
import ModelTrainingItem from "@/components/creatorcenter/modeltrainingitem";
import TraingResultModal from "@/components/creatorcenter/trainingResultModal";
import EditModelDetailModal from "@/components/creatorcenter/editModelDetailModal";
import NewTrainingModal from "@/components/creatorcenter/newTrainingModal";

const MyModels = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const NewTrainingControl = useDisclosure();
  const ResultControl = useDisclosure();
  const editControl = useDisclosure();
  const [searchValue, setSearchValue] = useState("");

  const searchWidth = useBreakpointValue({
    base: "160px",
    md: "220px",
    lg: "400px",
  });

  const column = useBreakpointValue({
    base: 1, // 屏幕宽度小于40em（640px）时的值
    sm: 1, // 屏幕宽度在40em-52em（640px-853px）之间时的值
    md: 2, // 屏幕宽度在52em-64em（853px-1024px）之间时的值
    lg: 3, // 屏幕宽度在64em-80em（1024px-1280px）之间时的值
    xl: 4, // 屏幕宽度在80em-100em（1280px-1920px）之间时的值
  });

  const [trainsList, setTrainsList] = useState<MyModelDetail[]>([]);

  const [getTrains] = useLazyGetTrainsQuery();

  const updataTrainList = async () => {
    const dataList = await getTrains({ user_id: user.id });
    if (dataList.data) {
      setTrainsList(dataList.data);
    }
  };
  useEffect(() => {
    updataTrainList();
  }, []);

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleOpenResult = () => {
    ResultControl.onOpen();
  };

  const handleOpenPublish = () => {
    editControl.onOpen();
  };
  return (
    <Box h="100%" pl="20px" pr="20px">
      <Box
        h="100%"
        overflow={"auto"}
        borderWidth="1px"
        borderColor={"#DCE0EB"}
        p="20px"
      >
        <Flex mb="30px" justifyContent={"space-between"} alignItems="center">
          <Box fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
            我的模型
          </Box>
          <HStack>
            <InputGroup w={searchWidth}>
              <Input
                h="40px"
                boxSizing="border-box"
                border="1px solid #CBD1DF"
                borderRadius={0}
                bg="none"
                color={"#8E94A9"}
                fontSize="12px"
                placeholder="搜索你想要的内容..."
                size="md"
                value={searchValue}
                onChange={handleChangeSearchValue}
              />
              <InputRightElement>
                <SlMagnifier color="#CBD1DF" />
              </InputRightElement>
            </InputGroup>
            <Button
              borderRadius={0}
              width={"90px"}
              height={"40px"}
              color="#FFFFFF"
              bgColor="#496AE1"
              fontWeight={"normal"}
              fontSize="12px"
              _hover={{
                bgColor: "#3F5BC1",
                color: "#E6E6E6",
              }}
              leftIcon={<RiBox3Line size={"16px"} />}
              onClick={() => navigate("/creatorcenter/modeltraning")}
            >
              模型训练
            </Button>
          </HStack>
        </Flex>
        <Flex
          mb="20px"
          justifyContent={"space-between"}
          alignItems="center"
          borderBottom={"1px solid #CBD1DF"}
        >
          <Box
            fontSize={"16px"}
            color={"#27314D"}
            borderColor="#27314D"
            borderBottom={"4px"}
          >
            全部内容
          </Box>
          <Flex alignItems={"center"}>
            <Text fontSize={"12px"} color={"#8E94A9"}>
              筛选条件:{" "}
            </Text>
            <Select
              color={"#27314D"}
              fontSize={"12px"}
              w="100px"
              border={"none"}
              size="xs"
            >
              <option>最新</option>
            </Select>
            <Box ml={"30px"} fontSize={"13px"} color={"#27314D"}>
              共40个内容
            </Box>
          </Flex>
        </Flex>
        <Box>
          <SimpleGrid columns={column} spacing={"40px 20px"}>
            {/* {myModel && myModel.map(item => (
              <Box key={item.id}>
                <ModelItem myModel={item} />
              </Box>
            ))} */}
            {trainsList &&
              trainsList.map((item) => (
                <Box w="100%" key={item.id}>
                  <ModelTrainingItem
                    myModel={item}
                    handleOpenResult={handleOpenResult}
                  />
                </Box>
              ))}
          </SimpleGrid>
        </Box>
      </Box>
      <NewTrainingModal
        isOpen={NewTrainingControl.isOpen}
        onClose={NewTrainingControl.onClose}
        handleOpenResult={handleOpenResult}
      />
      <TraingResultModal
        isOpen={ResultControl.isOpen}
        onClose={ResultControl.onClose}
        handleOpenPublish={handleOpenPublish}
      />
      <EditModelDetailModal
        isOpen={editControl.isOpen}
        onClose={editControl.onClose}
      />
    </Box>
  );
};

export default MyModels;
